<template>
  <div class="register">
    <nav-bar
      fixed
      z-index="99"
      title="登录"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
      right-text="教练登录"
      @click-right="$router.push('/coach_login')"
    />
    <div style="height: 46px"></div>
    <div class="register-title">用户登录</div>

    <form class="register-form" @submit.prevent="submit">
      <div>
        <div class="register-form-name"><span>*</span>手机号</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <input class="w-f" placeholder="请输入手机号" v-model="username" />
        </div>
        <!-- <div class="register-form-name"><span>*</span>验证码</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <input style="width: 3rem;" placeholder="请输入验证码" v-model="captcha" />
          <div class="text-num" @click="code">{{ text }}</div>
        </div> -->

        <div class="register-form-name"><span>*</span>密码</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <input style="width: 3rem;" placeholder="请输入密码" v-model="password" />
        </div>
        <div style="font-size: 0.23rem;margin-top: 0.6rem;color: #999999;">
          <Checkbox shape="square" v-model="agree" checked-color="#0ce6df">
            我已阅读并同意
            <router-link :to="'/view_detail/41'" style="color: #0ce6df"
              >《用户协议》</router-link
            >
            和
            <router-link :to="'/view_detail/49'" style="color: #0ce6df"
              >《隐私政策》</router-link
            >
          </Checkbox>
        </div>
        <div class="btn" style="margin-top: 0.4rem" @click="submit">
          登录账号
        </div>
      </div>
      <!-- <div
        class="btn"
        style="margin-top: 0.43rem"
        v-if="isWeixin"
        @click="weixinLogin"
      >
        <img style="width: 0.4rem;vertical-align: middle;margin-right: 0.2rem;" src="@assets/img/weixin.png"/>微信一键登录
      </div> -->
    </form>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { login, registerVerify } from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";
import { Checkbox, NavBar } from "vant";
import { isWeixin } from "@utils/index";

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  components: { Checkbox, NavBar },
  mixins: [sendVerifyCode],
  data: function () {
    return {
      username: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      agree: false,
      isWeixin: isWeixin(),
    };
  },
  created(){
    if(this.$route.query && this.$route.query.errorTip){
      this.username = cookie.get('username');
      this.captcha = cookie.get('captcha');
      cookie.remove('username')
      cookie.remove('captcha')
      this.agree = true;
      this.$dialog.error(decodeURIComponent(this.$route.query.errorTip));
    }
  },
  methods: {
    weixinLogin() {
      if (!this.agree) {
        this.$dialog.toast({ mes: "请勾选阅读并同意用户协议" });
        return;
      }
      const module = () => import("@libs/wechat");
      module().then((Module) => {
        Module.default().then(() => Module.oAuth());
      });
    },
    async code() {
      var that = this;
      const { username } = that;
      try {
        await that
          .$validator({
            username: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
          })
          .validate({ username });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      await registerVerify({ phone: that.username, type: "login" })
        .then((res) => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },
    async submit() {
      if (!this.agree) {
        this.$dialog.toast({ mes: "请勾选阅读并同意用户协议" });
        return;
      }
      const { username, password } = this;
      try {
        // await this.$validator({
        //   username: [
        //     required(required.message("账号")),
        //     attrs.range([5, 16], attrs.range.message("账号")),
        //     alpha_num(alpha_num.message("账号")),
        //   ],
        //   captcha: [
        //     required(required.message("验证码")),
        //     attrs.range([6, 16], attrs.range.message("验证码")),
        //     alpha_num(alpha_num.message("验证码")),
        //   ],
        // }).validate({ username, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      cookie.set('username', username);
      cookie.set('password', password);
      const module = () => import("@libs/wechat");
      if(this.isWeixin){
        module().then((Module) => {
          Module.default().then(() => Module.toBaseLogin());
        });
      }else{
        login({
          username,
          password,
          userCategory: 1,
          spread: cookie.get("spread"),
        })
          .then(({ data }) => {
            this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
            this.$store.commit("SET_USER", data);
            const backUrl = cookie.get(BACK_URL) || "/";
            cookie.remove(BACK_URL);
            this.$router.replace({ path: '/' });
          })
          .catch((e) => {
            this.$dialog.error(e.msg);
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.register {
  padding: 0.77rem 0.64rem;
  height: 100vh;
  background: #ffffff;
  position: relative;
  .register-title {
    font-size: 0.42rem;
    font-weight: 700;
  }
  .register-title-text {
    color: #999999;
    margin-top: 0.19rem;
  }
  .register-form {
    margin-top: 0.23rem;
  }
  .register-form-name {
    margin-bottom: 0.19rem;
    margin-top: 0.44rem;
  }
  .register-form-input {
    height: 0.78rem;
    padding: 0 0.23rem;
    background-color: #f8f8f8;
    border-radius: 2rem;
  }
  .text-num {
    color: #b9bde5;
  }
  .btn {
    display: block;
    color: #fff;
    width: 100%;
    height: 0.68rem;
    background: #0ce6df;
    line-height: 0.68rem;
    text-align: center;
    border-radius: 0.5rem;
  }
  .bottom {
    margin-top: 0.3rem;
    color: #999999;
  }
}
</style>
